import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from 'src/app/shared/service/connected-dialog';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { ContactSupportTipsComponent } from './contact-support-tips/contact-support-tips.component';

@Injectable({
  providedIn: 'root',
})
export class HelpCenterService {
  constructor(
    private appService: AppService,
    private router: Router,
    private localeService: LocaleService,
    private toast: ToastService,
    private matConnectedDialog: MatConnectedDialog,
  ) {}
  /** 常见问题 */
  faqList$: BehaviorSubject<any> = new BehaviorSubject([]);

  /** 公告中心 */
  announcementList$: BehaviorSubject<any> = new BehaviorSubject([]);

  /** 最近发布文章 */
  latestArtilceList$: BehaviorSubject<any> = new BehaviorSubject([]);

  /** 热门文章 */
  hotArtilceList$: BehaviorSubject<any> = new BehaviorSubject([]);

  /**最新公告 */
  latestAnnouncement$: BehaviorSubject<any> = new BehaviorSubject([]);

  /** 常见问题List订阅 */
  faqArticleListById$!: Observable<any>;

  /**
   * 去除p 标签
   *
   * @param str string html
   * @returns
   */
  deleteHtmlPTag(str: string) {
    str = str.replace(/<.*?>/gi, '');
    return str;
  }

  /**
   * 详情页面
   *
   * @param item
   * @item list中的数据
   */
  jumpToDetailPage(item: any) {
    this.router.navigate(
      [this.appService.languageCode, 'help-center', item.categoryCode.toLowerCase(), item.categoryId],
      {
        queryParams: {
          articleCode: item.id,
        },
      },
    );
  }

  checkSearchContent() {
    this.toast.show({
      message: this.localeService.getValue('search_content_cannot_be_empty'),
      title: this.localeService.getValue('hint'),
      type: 'fail',
    });
  }

  /**
   * 顯示自動登出彈窗
   */
  showLogoutPopup() {
    this.matConnectedDialog
      .open(ContactSupportTipsComponent, {
        data: {
          header: this.localeService.getValue('logged_out'),
          message: this.localeService.getValue('you_have_been_automatically_logged_out'),
        },
        disableClose: true, // 強制要求點擊按鈕，關閉backdrop無效
        mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
        mobileFixedBottom: true,
      })
      .afterClosed()
      .subscribe(() => {
        window.location.reload();
      });
  }

  /**
   * 顯示無法登入彈窗
   */
  showUnableLoginPopup() {
    this.matConnectedDialog
      .open(ContactSupportTipsComponent, {
        data: {
          header: this.localeService.getValue('unable_to_log_in'),
          message: this.localeService.getValue('your_account_is_unable_to_log_in'),
        },
        disableClose: true, // 強制要求點擊按鈕，關閉backdrop無效
        mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
        mobileFixedBottom: true,
      })
      .afterClosed()
      .subscribe(() => {
        window.location.reload();
      });
  }
}
